module.exports = __webpack_public_path__ + "img/icn_warning.0e4205d0.svg";